export default {
  'dashboard.title': 'Dashboard',
  'dashboard.welcome': 'Welcome back, {{name}}',
  'dashboard.subtitle': 'Here is what needs your attention today',

  'dashboard.menu.group.main': 'Main',
  'dashboard.menu.group.products': 'Products',
  'dashboard.menu.group.account': 'Account',
  'dashboard.menu.welcomeBack': 'Welcome back',
  'dashboard.menu.backToHome': 'Back to Home',

  'dashboard.status.quotes': 'Pending Quotes',
  'dashboard.status.orders': 'Active Orders',
  'dashboard.status.messages': 'Unread Messages',
  'dashboard.status.aiPreviews': 'AI Previews Ready',
  'dashboard.status.payments': 'Pending Payments',
  'dashboard.status.shipping': 'In Transit',

  'dashboard.actionRequired': 'Action Required',
  'dashboard.actionPriority.high': 'High',
  'dashboard.actionPriority.medium': 'Medium',
  'dashboard.actionPriority.low': 'Low',

  'dashboard.recentQuotes.title': 'Recent Quotes',
  'dashboard.recentQuotes.quoteNumber': 'Quote #',
  'dashboard.recentQuotes.product': 'Product',
  'dashboard.recentQuotes.finish': 'Finish',
  'dashboard.recentQuotes.quantity': 'Qty',
  'dashboard.recentQuotes.status': 'Status',
  'dashboard.recentQuotes.amount': 'Amount',
  'dashboard.recentQuotes.view': 'View Quote',
  'dashboard.recentQuotes.viewAll': 'View All Quotes',
  'dashboard.recentQuotes.requestNew': 'Request New Quote',
  'dashboard.recentQuotes.empty': 'No quotes yet. Start by requesting a quote for your packaging needs.',

  'dashboard.aiPreviews.title': 'AI Finish Previews',
  'dashboard.aiPreviews.original': 'Original',
  'dashboard.aiPreviews.generated': 'Generated',
  'dashboard.aiPreviews.product': 'Product',
  'dashboard.aiPreviews.finish': 'Finish',
  'dashboard.aiPreviews.status': 'Status',
  'dashboard.aiPreviews.view': 'View Preview',
  'dashboard.aiPreviews.requestQuote': 'Request Quote',
  'dashboard.aiPreviews.readyCta': 'Ready to request a quote',
  'dashboard.aiPreviews.empty': 'No AI previews yet. Generate a preview to see how your packaging will look.',

  'dashboard.orders.title': 'Active Orders',
  'dashboard.orders.orderNumber': 'Order #',
  'dashboard.orders.quoteRef': 'Quote Ref',
  'dashboard.orders.product': 'Product',
  'dashboard.orders.payment': 'Payment',
  'dashboard.orders.production': 'Production',
  'dashboard.orders.shipping': 'Shipping',
  'dashboard.orders.total': 'Total',
  'dashboard.orders.delivery': 'Est. Delivery',
  'dashboard.orders.view': 'View Order',
  'dashboard.orders.empty': 'No active orders yet. Approved quotes will appear here after order confirmation.',

  'dashboard.payments.title': 'Payment Status',
  'dashboard.payments.date': 'Date',
  'dashboard.payments.reference': 'Reference',
  'dashboard.payments.amount': 'Amount',
  'dashboard.payments.status': 'Status',
  'dashboard.payments.method': 'Method',
  'dashboard.payments.empty': 'No payment history yet.',

  'dashboard.shipping.title': 'Shipping Status',
  'dashboard.shipping.order': 'Order #',
  'dashboard.shipping.carrier': 'Carrier',
  'dashboard.shipping.tracking': 'Tracking #',
  'dashboard.shipping.status': 'Status',
  'dashboard.shipping.delivery': 'Est. Delivery',
  'dashboard.shipping.view': 'View Details',
  'dashboard.shipping.empty': 'No active shipments yet.',

  'dashboard.messages.title': 'Message Center',
  'dashboard.messages.related': 'Related',
  'dashboard.messages.unread': 'Unread',
  'dashboard.messages.open': 'Open Message',
  'dashboard.messages.empty': 'No messages yet.',

  'dashboard.samples.title': 'Sample Production Requests',
  'dashboard.samples.requestNumber': 'Request #',
  'dashboard.samples.product': 'Product',
  'dashboard.samples.finish': 'Finish',
  'dashboard.samples.quantity': 'Qty',
  'dashboard.samples.status': 'Status',
  'dashboard.samples.cost': 'Est. Cost',
  'dashboard.samples.view': 'View Sample Request',
  'dashboard.samples.empty': 'No sample requests yet.',

  'dashboard.files.title': 'Uploaded Files',
  'dashboard.files.name': 'File',
  'dashboard.files.type': 'Type',
  'dashboard.files.purpose': 'Purpose',
  'dashboard.files.related': 'Related',
  'dashboard.files.view': 'View',
  'dashboard.files.empty': 'No uploaded files yet.',

  'dashboard.savedProducts.title': 'Saved Products',
  'dashboard.savedProducts.category': 'Category',
  'dashboard.savedProducts.sku': 'SKU',
  'dashboard.savedProducts.view': 'View Product',
  'dashboard.savedProducts.quote': 'Request Quote',
  'dashboard.savedProducts.preview': 'AI Preview',
  'dashboard.savedProducts.empty': 'No saved products yet. Browse packaging products and save your favorites.',

  'dashboard.company.title': 'Company Profile',
  'dashboard.company.completion': '{{percent}}% complete',
  'dashboard.company.missing': 'Missing:',
  'dashboard.company.completeButton': 'Complete Company Profile',

  'dashboard.market.title': 'Market Settings',
  'dashboard.market.country': 'Country',
  'dashboard.market.language': 'Language',
  'dashboard.market.displayCurrency': 'Display Currency',
  'dashboard.market.quoteBase': 'Quote Base Currency',
  'dashboard.market.exchangeRate': 'Rate as of',
  'dashboard.market.change': 'Change Preferences',

  'dashboard.status.quoted': 'Quoted',
  'dashboard.status.submitted': 'Submitted',
  'dashboard.status.accepted': 'Accepted',
  'dashboard.status.rejected': 'Rejected',
  'dashboard.status.draft': 'Draft',
  'dashboard.status.expired': 'Expired',

  'dashboard.paymentStatus.pending': 'Pending',
  'dashboard.paymentStatus.completed': 'Completed',
  'dashboard.paymentStatus.failed': 'Failed',
  'dashboard.paymentStatus.refunded': 'Refunded',
  'dashboard.paymentStatus.partial': 'Partial',

  'dashboard.productionStatus.not_started': 'Not Started',
  'dashboard.productionStatus.in_progress': 'In Progress',
  'dashboard.productionStatus.completed': 'Completed',

  'dashboard.shippingStatus.not_shipped': 'Not Shipped',
  'dashboard.shippingStatus.packing': 'Packing',
  'dashboard.shippingStatus.shipped': 'Shipped',
  'dashboard.shippingStatus.delivered': 'Delivered',

  'dashboard.shipmentStatus.pre_transit': 'Pre-Transit',
  'dashboard.shipmentStatus.in_transit': 'In Transit',
  'dashboard.shipmentStatus.out_for_delivery': 'Out for Delivery',
  'dashboard.shipmentStatus.delivered': 'Delivered',
  'dashboard.shipmentStatus.exception': 'Exception',

  'dashboard.sampleStatus.requested': 'Requested',
  'dashboard.sampleStatus.under_review': 'Under Review',
  'dashboard.sampleStatus.quoted': 'Quoted',
  'dashboard.sampleStatus.in_production': 'In Production',
  'dashboard.sampleStatus.shipped': 'Shipped',
  'dashboard.sampleStatus.completed': 'Completed',
  'dashboard.sampleStatus.cancelled': 'Cancelled',

  'dashboard.aiStatus.queued': 'Queued',
  'dashboard.aiStatus.processing': 'Processing',
  'dashboard.aiStatus.completed': 'Completed',
  'dashboard.aiStatus.failed': 'Failed',

  'dashboard.filePurpose.image_search': 'Image Search',
  'dashboard.filePurpose.quote_reference': 'Quote Reference',
  'dashboard.filePurpose.ai_finish_source': 'AI Finish Source',
  'dashboard.filePurpose.sample_reference': 'Sample Reference',
  'dashboard.filePurpose.order_document': 'Order Document',

  'dashboard.seeAll': 'See all',
  'dashboard.noData': '—',

  // Company Profile Page
  'companyProfile.pageTitle': 'Company Profile',
  'companyProfile.subtitle': 'Manage your company information for quotes, orders, shipping, and business communication.',
  'companyProfile.section.companyInfo': 'Company Information',
  'companyProfile.section.contactInfo': 'Contact Information',
  'companyProfile.section.businessInfo': 'Business Information',
  'companyProfile.section.accountStatus': 'Account Status',
  'companyProfile.field.companyName': 'Company Name',
  'companyProfile.field.country': 'Country',
  'companyProfile.field.businessType': 'Business Type',
  'companyProfile.field.website': 'Website',
  'companyProfile.field.contactEmail': 'Contact Email',
  'companyProfile.field.contactPhone': 'Contact Phone',
  'companyProfile.field.taxId': 'Tax ID / VAT Number',
  'companyProfile.field.companySize': 'Company Size',
  'companyProfile.field.status': 'Status',
  'companyProfile.status.active': 'Active',
  'companyProfile.status.inactive': 'Inactive',
  'companyProfile.status.suspended': 'Suspended',
  'companyProfile.statusNotice': 'Please contact support if your company account status needs review.',
  'companyProfile.saveButton': 'Save Changes',
  'companyProfile.saving': 'Saving...',
  'companyProfile.successMessage': 'Company profile updated successfully.',
  'companyProfile.errorMessage': 'Failed to save company profile. Please try again.',
  'companyProfile.validation.required': 'This field is required',
  'companyProfile.validation.email': 'Please enter a valid email address',
  'companyProfile.validation.url': 'Please enter a valid URL',
  'companyProfile.selectPlaceholder': 'Select...',
  'companyProfile.createdAt': 'Created',
  'companyProfile.updatedAt': 'Last Updated',
};